import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormField,
  FormLabel,
} from "@acdc2/ui/components/access-form";
import { ListType } from "../../client/generated";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@acdc2/ui/components/select";

type Props = ComponentProps<typeof Select>;

export function ListFormField(props: Props) {
  const { t } = useTranslation();

  return (
    <FormField name="listType">
      <FormLabel>{t("ListFormField.label")}</FormLabel>
      <Select {...props}>
        <FormControl asChild>
          <SelectTrigger className="w-full">
            <SelectValue placeholder={t("ListFormField.placeholder")} />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          <SelectItem value={ListType.None}>
            {t("ListFormField.options.none")}
          </SelectItem>
          <SelectItem value={ListType.Unordered}>
            {t("ListFormField.options.unordered")}
          </SelectItem>
          <SelectItem value={ListType.Description}>
            {t("ListFormField.options.description")}
          </SelectItem>
          <SelectItem value={ListType.Disc}>
            {t("ListFormField.options.disc")}
          </SelectItem>
          <SelectItem value={ListType.Circle}>
            {t("ListFormField.options.circle")}
          </SelectItem>
          <SelectItem value={ListType.Square}>
            {t("ListFormField.options.square")}
          </SelectItem>
          <SelectItem value={ListType.Ordered}>
            {t("ListFormField.options.ordered")}
          </SelectItem>
          <SelectItem value={ListType.Decimal}>
            {t("ListFormField.options.decimal")}
          </SelectItem>
          <SelectItem value={ListType.UpperRoman}>
            {t("ListFormField.options.roman.upper")}
          </SelectItem>
          <SelectItem value={ListType.LowerRoman}>
            {t("ListFormField.options.roman.lower")}
          </SelectItem>
          <SelectItem value={ListType.UpperAlpha}>
            {t("ListFormField.options.alpha.upper")}
          </SelectItem>
          <SelectItem value={ListType.LowerAlpha}>
            {t("ListFormField.options.alpha.lower")}
          </SelectItem>
        </SelectContent>
      </Select>
    </FormField>
  );
}
